//import BillingHandler from "../../lib/BillingHandler";
// leave a noop middleware in case we need it later
const billingMiddleware = store => {
  //const billingHandler = new BillingHandler(store);
  return next => async action => {
    next(action);
  };
};

export default billingMiddleware;
